import { ReactNode } from 'react';
import styled from 'styled-components';
import { colors } from '../../../styles/GlobalStyles';

const getColor = (props: any) => {
  if (props.isDragAccept) {
    return colors.success500;
  }
  if (props.isDragReject) {
    return colors.error500;
  }
  if (props.isFocused) {
    return colors.success500;
  }
  return colors.neutral400;
};

const Container = styled.div`
  flex: 1;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  border-width: 2px;
  border-radius: 12px;
  border-color: ${(props) => getColor(props)};
  border-style: dashed;
  outline: none;
  transition: border 0.24s ease-in-out;
  margin: 0 0 20px 0;
`;

interface DropzoneType {
  getRootProps: any;
  isDragAccept: boolean;
  isDragReject: boolean;
  children: ReactNode;
}

export const Dropzone = ({
  getRootProps,
  isDragAccept,
  isDragReject,
  children
}: DropzoneType) => {
  return (
    <Container {...getRootProps({ isDragAccept, isDragReject })}>
      {children}
    </Container>
  );
};
